<app-loader [loading]="isLoading" [fullPage]="true" [title]="'chargement'"></app-loader>
<section *ngIf="!isLoading" class="simulation grid-container grid-container--section no-gutter-mobile" data-overload-controller="AdhesionPegaseCtrl">
    <app-stepper-component [currentStepId]="currentStepId"></app-stepper-component>
    <div>
        <form>
            <fieldset class="simulation__step" name="adhesionForm">
                <legend style="display: none">
                    {{ 'signature.title.' + contextDossier.emprunteur.assurance.statutDA | i18n }}
                </legend>
                <div>
                    <section class="signature">
                        <div class="simulation__group" *ngIf="!iframeError">
                            <h1 class="page-title page-title--primary">
                                {{ 'signature.title.' + contextDossier.emprunteur.assurance.statutDA | i18n }}
                            </h1>
                            <ng-container *ngIf="!isPropositionSigned">
                                <div class="simulation__content">
                                    <div>
                                        <div class="simulation__group">
                                            <p class="page-subtitle page-subtitle--uppercase page-subtitle--primary">
                                                {{ 'signature.subtitle.' + contextDossier.emprunteur.assurance.statutDA + (contextDossier.emprunteur.topSansSelectionMedicale ? '.nomedicalselection' : '') | i18n }}
                                            </p>
                                            <p class="signature__message">
                                                {{ 'signature.message.' + contextDossier.emprunteur.assurance.statutDA | i18n }}
                                            </p>
                                            <div id="signatureFrameDiv" class="signature__iframe" [style.height]="iframeHeight">
                                                <iframe id="signatureFrame" name="signatureFrame" title="iframeSignature" [src]="signatureUrl" scrolling="no"> </iframe>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="simulation__buttons simulation__buttons--light">
                                    <div class="grid-6 grid-mobile-2 no-gutter">
                                        <button id="goBackToEspaceClient" type="button" class="button--previous-accueil" (click)="goBackToEspaceClientModal = true">
                                            {{ 'signature.button.home' | i18n }}
                                        </button>
                                    </div>
                                </div>
                            </ng-container>
                            <div class="finalisation signed-with-no-certificate" *ngIf="isPropositionSigned">
                                <div class="finalisation--content">
                                    <div class="finalisation--bottom">
                                        {{ 'finalisation.footer.text1' | i18n }}
                                    </div>
                                </div>
                                <div class="finalisation--button">
                                    <button
                                        id="button-finalisation-id"
                                        type="button"
                                        data-tag-commander=""
                                        data-tagcommander-id="tagCo.finalisation.previous.button"
                                        class="button button--primary button--next centered"
                                        (click)="navigateToEspaceClient()"
                                    >
                                        {{ 'global.button.back-to-home' | i18n }}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="simulation__group" *ngIf="iframeError">
                            <h1 class="page-title page-title--primary">
                                {{ 'signature.title.' + contextDossier.emprunteur.assurance.statutDA | i18n }}
                            </h1>
                            <div class="simulation__content">
                                <div class="simulation__group signature__error" data-ng-if="signature.displayedErrorBlock">
                                    <p class="signature__error-icon"></p>
                                    <p class="signature__error-subtitle">
                                        {{ 'signature.afterError.subtitle' | i18n }}
                                    </p>
                                    <p class="signature__message">
                                        {{ 'signature.afterError.message' | i18n }}
                                    </p>
                                </div>
                            </div>
                            <div class="simulation__buttons simulation__buttons--light">
                                <button class="button button--primary button--next centered" (click)="navigateToEspaceClient()">
                                    {{ 'signature.afterError.next' | i18n }}
                                </button>
                            </div>
                        </div>
                    </section>
                </div>
            </fieldset>
        </form>
    </div>
</section>
<app-validation-modal-component
    [modalTitle]="'adhesion.backToDashboard.modal.title'"
    [content]="'adhesion.backToDashboard.modal.body'"
    [buttonLeft]="'global.no'"
    [buttonRight]="'global.yes'"
    [visibility]="goBackToEspaceClientModal"
    (crossClick)="goBackToEspaceClientModal = false"
    (leftClick)="goBackToEspaceClientModal = false"
    (rightClick)="navigateToEspaceClient()"
>
</app-validation-modal-component>

<app-simple-message-modal [visibility]="iframeError" [modalTitle]="'signature.error.title'" [content]="'signature.error.message'" [closeButton]="'global.close'"></app-simple-message-modal>
<app-steps-adhesion-modal *ngIf="currentStepId === 'signature_dad'" [currentStepId]="'signature_dad'"></app-steps-adhesion-modal>
